import React, { type ReactNode } from 'react';
import { PageProviders } from '@/app/components/hotel-detail/PageProviders';
import { PageLayout } from '@/app/components/hotel-detail/PageLayout';
import type { BrandedProps } from '@/app/hotel-detail/createHotelDetailData';

export type BrandedPageProps = {
  children: ReactNode;
} & BrandedProps;

export default function BrandedPage(props: BrandedPageProps) {
  const { children, initialParams } = props;

  return (
    <PageProviders initialParams={initialParams}>
      <PageLayout>{children}</PageLayout>
    </PageProviders>
  );
}
